export const ESTADOS = {
  AC: 'ACRE',
  AL: 'ALAGOAS',
  AP: 'AMAPÁ',
  AM: 'AMAZONAS',
  BA: 'BAHIA',
  CE: 'CEARÁ',
  DF: 'DISTRITO FEDERAL',
  ES: 'ESPÍRITO SANTO',
  GO: 'GOIÁS',
  MA: 'MARANHÃO',
  MT: 'MATO GROSSO',
  MS: 'MATO GROSSO DO SUL',
  MG: 'MINAS GERAIS',
  PA: 'PARÁ',
  PB: 'PARAÍBA',
  PR: 'PARANÁ',
  PE: 'PERNAMBUCO',
  PI: 'PIAUÍ',
  RJ: 'RIO DE JANEIRO',
  RN: 'RIO GRANDE DO NORTE',
  RS: 'RIO GRANDE DO SUL',
  RO: 'RONDÔNIA',
  RR: 'RORAIMA',
  SC: 'SANTA CATARINA',
  SP: 'SÃO PAULO',
  SE: 'SERGIPE',
  TO: 'TOCANTINS',
}

export function normalizeUf(uf) {
  return String(uf || '')
    .trim()
    .toUpperCase()
}

export function getEstadoLabel(uf) {
  const sigla = normalizeUf(uf)
  return ESTADOS[sigla] || uf
}

export function buildUfOptions(items, ufField = null) {
  const siglas = new Set()

  if (Array.isArray(items)) {
    if (typeof items[0] === 'string' || items.length === 0) {
      items.forEach(s => {
        const sNorm = normalizeUf(s)
        if (sNorm) siglas.add(sNorm)
      })
    } else if (ufField) {
      items.forEach(o => {
        const sNorm = normalizeUf(o && o[ufField])
        if (sNorm) siglas.add(sNorm)
      })
    }
  }

  return Array.from(siglas)
    .sort()
    .map(sigla => ({
      label: getEstadoLabel(sigla),
      value: sigla,
    }))
}
